import { z } from "zod";

function normalizeIrlPhone(value: string) {
  return value.replace(/[\s\-().]/g, "");
}

const irlPhonePattern = /^(\+353|00353|0)[1-9]\d{7,9}$/;

function isValidIrlPhone(value: string) {
  return irlPhonePattern.test(normalizeIrlPhone(value));
}

const irlPhone = z
  .string()
  .min(1, { message: "Phone Number is required" })
  .refine(isValidIrlPhone, {
    message: "Phone number must be a valid Irish number",
  });

export { irlPhone, isValidIrlPhone, normalizeIrlPhone };
